export class OfferActivity{
  action: string;
  createdDate: string;
  info:any;
  user:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/offerActivity.ts